export const errorMessages: {
  [key: string]: string
} = {}
